import React from 'react';
import {Redirect, Link} from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import Select from 'react-select';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import {withStyles} from '@material-ui/core/styles';
import ApiFetcher from '../../ApiFetcher';
import Utility from '../../Utility';
import PlantManagementUtility from "./PlantManagementUtility";
import encoding from 'encoding-japanese';
import * as ExcelJS from 'exceljs';
import _ from 'lodash';

const styles = theme => ({
    select: {
        textAlign: 'left',
        margin: 'auto',
        color: theme.palette.text.primary,
        '& input': {
            font: 'inherit',
        },
        width: 'auto',
    },
    button: {
        margin: 'auto',
        width: '30%',
        marginTop: theme.spacing.unit * 8,
    },
    buttonDiv: {
        margin: 'auto',
        width: '100%',
    },
    circularProgress: {
        textAlign: 'center',
        marginTop: theme.spacing.unit * 5,
    },
    form: {
        textAlign: 'center',
        width: '90%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
});

// 熱交停止完了チェック処理対象プロパティ：resultOfCrisGan1ConstructionMethod：洗浄範囲（実績　内面　ｶﾞﾝ①）
const checkCrisGan1 = [
    'resultOfCrisGan1IsStart', 'resultOfCrisGan1IsStop', 'resultOfCrisGan1IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrisGan2ConstructionMethod：洗浄範囲（実績　内面　ｶﾞﾝ②）
const checkCrisGan2 = [
    'resultOfCrisGan2IsStart', 'resultOfCrisGan2IsStop', 'resultOfCrisGan2IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrisFlexi1ConstructionMethod：洗浄範囲（実績　内面　ﾌﾚｷ①）
const checkCrisFlexi1 = [
    'resultOfCrisFlexi1IsStart', 'resultOfCrisFlexi1IsStop', 'resultOfCrisFlexi1IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrisFlexi2ConstructionMethod：洗浄範囲（実績　内面　ﾌﾚｷ②）
const checkCrisFlexi2 = [
    'resultOfCrisFlexi2IsStart', 'resultOfCrisFlexi2IsStop', 'resultOfCrisFlexi2IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrisEquipment1ConstructionMethod：洗浄範囲（実績　内面　装置①）
const checkCrisEquipment1 = [
    'resultOfCrisEquipment1IsStart', 'resultOfCrisEquipment1IsStop', 'resultOfCrisEquipment1IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrisEquipment2ConstructionMethod：洗浄範囲（実績　内面　装置②）
const checkCrisEquipment2 = [
    'resultOfCrisEquipment2IsStart', 'resultOfCrisEquipment2IsStop', 'resultOfCrisEquipment2IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrisLance1ConstructionMethod：洗浄範囲（実績　内面　ﾗﾝｽ①）
const checkCrisLance1 = [
    'resultOfCrisLance1IsStart', 'resultOfCrisLance1IsStop', 'resultOfCrisLance1IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrisLance2ConstructionMethod：洗浄範囲（実績　内面　ﾗﾝｽ②）
const checkCrisLance2 = [
    'resultOfCrisLance2IsStart', 'resultOfCrisLance2IsStop', 'resultOfCrisLance2IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrosGan1ConstructionMethod：洗浄範囲（実績　外面　ｶﾞﾝ①）
const checkCrosGan1 = [
    'resultOfCrosGan1IsStart', 'resultOfCrosGan1IsStop', 'resultOfCrosGan1IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrosGan2ConstructionMethod：洗浄範囲（実績　外面　ｶﾞﾝ②）
const checkCrosGan2 = [
    'resultOfCrosGan2IsStart', 'resultOfCrosGan2IsStop', 'resultOfCrosGan2IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrosEquipment1ConstructionMethod：洗浄範囲（実績　外面　装置①）
const checkCrosEquipment1 = [
    'resultOfCrosEquipment1IsStart', 'resultOfCrosEquipment1IsStop', 'resultOfCrosEquipment1IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrosEquipment2ConstructionMethod：洗浄範囲（実績　外面　装置②）
const checkCrosEquipment2 = [
    'resultOfCrosEquipment2IsStart', 'resultOfCrosEquipment2IsStop', 'resultOfCrosEquipment2IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrshNum1ConstructionMethod：洗浄範囲（実績　超高　本数①）
const checkCrshNum1 = [
    'resultOfCrshNum1IsStart', 'resultOfCrshNum1IsStop', 'resultOfCrshNum1IsComplete'
];
// 熱交停止完了チェック処理対象プロパティ：resultOfCrshNum2ConstructionMethod：洗浄範囲（実績　超高　本数②）
const checkCrshNum2 = [
    'resultOfCrshNum2IsStart', 'resultOfCrshNum2IsStop', 'resultOfCrshNum2IsComplete'
];
// 熱交停止完了チェック処理対象プロパティリスト
const checkTargetList = [
    checkCrisGan1, checkCrisGan2, checkCrisFlexi1, checkCrisFlexi2, checkCrisEquipment1, checkCrisEquipment2, checkCrisLance1, checkCrisLance2, checkCrosGan1, checkCrosGan2, checkCrosEquipment1, checkCrosEquipment2, checkCrshNum1, checkCrshNum2
];
// 予定工法プロパティ
const progressPlanArray = [
    'planOfCrInternalMpa', 'planOfCrExternalMpa', 'planOfCrSuperHigh', 'planOfProcessCarryInDate', 'planOfProcessAirBlow', 'planOfProcessEt', 'planOfProcessFtect', 'planOfProcessIris'
];
// 内面進捗判定チェック対象プロパティ(開始)
const checkCrisStart = [
    'resultOfCrisGan1IsStart', 'resultOfCrisGan2IsStart', 'resultOfCrisFlexi1IsStart', 'resultOfCrisFlexi2IsStart', 'resultOfCrisEquipment1IsStart', 'resultOfCrisEquipment2IsStart', 'resultOfCrisLance1IsStart', 'resultOfCrisLance2IsStart'
];
// 内面進捗判定チェック対象プロパティ(開始日時)
const checkCrisStartDate = [
    'resultOfCrisGan1StartDatetime', 'resultOfCrisGan2StartDatetime', 'resultOfCrisFlexi1StartDatetime', 'resultOfCrisFlexi2StartDatetime', 'resultOfCrisEquipment1StartDatetime', 'resultOfCrisEquipment2StartDatetime', 'resultOfCrisLance1StartDatetime', 'resultOfCrisLance2StartDatetime'
];
// 内面進捗判定チェック対象プロパティ(完了)
const checkCrisComplete = [
    'resultOfCrisGan1IsComplete', 'resultOfCrisGan2IsComplete', 'resultOfCrisFlexi1IsComplete', 'resultOfCrisFlexi2IsComplete', 'resultOfCrisEquipment1IsComplete', 'resultOfCrisEquipment2IsComplete', 'resultOfCrisLance1IsComplete', 'resultOfCrisLance2IsComplete'
];
// 内面進捗判定チェック対象プロパティ(完了日時)
const checkCrisCompleteDate = [
    'resultOfCrisGan1CompleteDatetime', 'resultOfCrisGan2CompleteDatetime', 'resultOfCrisFlexi1CompleteDatetime', 'resultOfCrisFlexi2CompleteDatetime', 'resultOfCrisEquipment1CompleteDatetime', 'resultOfCrisEquipment2CompleteDatetime', 'resultOfCrisLance1CompleteDatetime', 'resultOfCrisLance2CompleteDatetime'
];
 // 内面進捗判定チェック対象プロパティ(追加理由)
const checkCrisAdditionalReasonArray = [
    'resultOfCrisGan1AdditionalReason', 'resultOfCrisGan2AdditionalReason', 'resultOfCrisFlexi1AdditionalReason', 'resultOfCrisFlexi2AdditionalReason', 'resultOfCrisEquipment1AdditionalReason', 'resultOfCrisEquipment2AdditionalReason', 'resultOfCrisLance1AdditionalReason', 'resultOfCrisLance2AdditionalReason'
];
// 外面進捗判定チェック対象プロパティ(開始)
const checkCrosStart = [
    'resultOfCrosGan1IsStart', 'resultOfCrosGan2IsStart', 'resultOfCrosEquipment1IsStart', 'resultOfCrosEquipment2IsStart'
];
// 外面進捗判定チェック対象プロパティ(開始日時)
const checkCrosStartDate = [
    'resultOfCrosGan1StartDatetime', 'resultOfCrosGan2StartDatetime', 'resultOfCrosEquipment1StartDatetime', 'resultOfCrosEquipment2StartDatetime'
];
// 外面進捗判定チェック対象プロパティ(完了)
const checkCrosComplete = [
    'resultOfCrosGan1IsComplete', 'resultOfCrosGan2IsComplete', 'resultOfCrosEquipment1IsComplete', 'resultOfCrosEquipment2IsComplete'
];
// 外面進捗判定チェック対象プロパティ(完了日時)
const checkCrosCompleteDate = [
    'resultOfCrosGan1CompleteDatetime', 'resultOfCrosGan2CompleteDatetime', 'resultOfCrosEquipment1CompleteDatetime', 'resultOfCrosEquipment2CompleteDatetime'
];
// 外面進捗判定チェック対象プロパティ(追加理由)
const checkCrosAdditionalReasonArray = [
    'resultOfCrosGan1AdditionalReason', 'resultOfCrosGan2AdditionalReason', 'resultOfCrosEquipment1AdditionalReason', 'resultOfCrosEquipment2AdditionalReason'
];
// 超高進捗判定チェック対象プロパティ(開始)
const checkCrshStart = [
    'resultOfCrshNum1IsStart', 'resultOfCrshNum2IsStart'
];
// 超高進捗判定チェック対象プロパティ(開始日時)
const checkCrshStartDate = [
    'resultOfCrshNum1StartDatetime', 'resultOfCrshNum2StartDatetime'
];
// 超高進捗判定チェック対象プロパティ(完了)
const checkCrshComplete = [
    'resultOfCrshNum1IsComplete', 'resultOfCrshNum2IsComplete'
];
// 超高進捗判定チェック対象プロパティ(完了日時)
const checkCrshCompleteDate = [
    'resultOfCrshNum1CompleteDatetime', 'resultOfCrshNum2CompleteDatetime'
];
// 超高進捗判定チェック対象プロパティ(追加理由)
const checkCrshAdditionalReasonArray = [
    'resultOfCrshNum1AdditionalReason', 'resultOfCrshNum2AdditionalReason'
];

export class DownloadConstructionPlan extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            sceneList: [],
            workPlace: null,
            csvLines: [],
            isWaitGetSceneList: false,
            isWaitDownload: false,
            alertDialogOpen: false,
            infoDialogCsvOpen: false,
            infoDialogXlsxOpen: false,
            message: [],
        };

        this.handleResponseGetSceneList = this.handleResponseGetSceneList.bind(this);
        this.getItemList = this.getItemList.bind(this);
        this.onChangeWorkPlace = this.onChangeWorkPlace.bind(this);
        this.handleDownloadCsv = this.handleDownloadCsv.bind(this);
        this.handleDownloadXlsx = this.handleDownloadXlsx.bind(this);
        this.handleResponseGetHeatExchanger = this.handleResponseGetHeatExchanger.bind(this);
        this.handleResponseGetHeatExchangerXlsx = this.handleResponseGetHeatExchangerXlsx.bind(this);
        this.makeCsv = this.makeCsv.bind(this);
        this.checkJson = this.checkJson.bind(this);
        this.json2csv = this.json2csv.bind(this);
        this.downloadCsv = this.downloadCsv.bind(this);
        this.downloadXlsx = this.downloadXlsx.bind(this);
        this.onAlartDialogClose = this.onAlartDialogClose.bind(this);
        this.onInfoDialogCloseCsv = this.onInfoDialogCloseCsv.bind(this);
        this.onInfoDialogCloseXlsx = this.onInfoDialogCloseXlsx.bind(this);

        if(this.props.onScreen !== undefined){
            this.props.onScreen('工事計画CSVダウンロード画面', true);
        }
    }

    componentDidMount(){
        this.setState({isWaitGetSceneList: true}, () => {
            ApiFetcher.getSceneList(this.props.cookies.get('token'), this.handleResponseGetSceneList);
        });
    }

    handleResponseGetSceneList(responseJson){
        if(Utility.isNullOrUndefined(responseJson.result) || Utility.isNullOrUndefined(responseJson.result.sceneNameList)){
            // 想定されるエラーは以下の通り.
            // + DBに工事計画CSVが存在しない
            // + トークン期限切れ
            // 画面が成立しないのでトップ画面に戻す.
            alert('工事計画CSVの取得に失敗したためトップ画面に戻ります。');
            this.props.history.push(this.props.backPath);
        }
        else{
            // 現場名一覧のソート.
            let sortSceneList = PlantManagementUtility.sortSceneList(responseJson.result.sceneNameList);
            this.setState({sceneList: sortSceneList, isWaitGetSceneList: false});
        }
    }

    getItemList(){
        return this.state.sceneList.map(scene => ({
            value: scene.csvId,
            label: scene.sceneName + "(" + scene.uploadDatetime + ")",
            fileName: scene.sceneName
        }));
    }

    onChangeWorkPlace = (e) => {
        this.setState({workPlace: e});
    }

    handleDownloadCsv = () => {
        this.setState({isWaitDownload: true}, () => {
            ApiFetcher.getHeatExchanger(this.props.cookies.get('token'), this.state.workPlace.value, this.handleResponseGetHeatExchanger);
        });
    }

    handleDownloadXlsx = () => {
        this.setState({isWaitDownload: true}, () => {
            ApiFetcher.getHeatExchanger(this.props.cookies.get('token'), this.state.workPlace.value, this.handleResponseGetHeatExchangerXlsx);
        });
    }

    handleResponseGetHeatExchanger(responseJson){
        if(Utility.isNullOrUndefined(responseJson.result) || Utility.isNullOrUndefined(responseJson.result.heatExchangerArray)){
            let errorMsg = [
                '選択した現場の工事計画がサーバにありません。'
            ];
            this.setState({message: errorMsg, isWaitDownload: false, alertDialogOpen: true});
        }else{
            this.makeCsv(responseJson.result.heatExchangerArray);
        }
    }

    handleResponseGetHeatExchangerXlsx(responseJson){
        if(Utility.isNullOrUndefined(responseJson.result) || Utility.isNullOrUndefined(responseJson.result.heatExchangerArray)){
            let errorMsg = [
                '選択した現場の工事計画がサーバにありません。'
            ];
            this.setState({message: errorMsg, isWaitDownload: false, alertDialogOpen: true});
        }else{
            this.makeXlsx(responseJson.result.heatExchangerArray);
        }
    }

    makeCsv(heatExchangerArray) {
        // 熱交停止完了チェック処理.
        let instrumentApparatusMachineNumber = this.checkJson(heatExchangerArray);
        
        // JSONをCSVに変換.
        let csvLines = this.json2csv(heatExchangerArray);

        // 文字コードをSJISに変換.
        let strArray = encoding.stringToCode(csvLines);
        let detected = encoding.detect(strArray);
        let sjisCsvLines = encoding.convert(strArray, {
                to: 'sjis',
                from: detected
        });

        this.setState({csvLines: sjisCsvLines, isWaitDownload: false}, () => {
            if(instrumentApparatusMachineNumber !== ''){
                // メッセージ出力.
                let infoMsg = [
                    '停止、完了されていない熱交(' + instrumentApparatusMachineNumber + ')があります。'
                ];
                this.setState({message: infoMsg, infoDialogCsvOpen: true});
            }else{
                // CSVファイル出力.
                this.downloadCsv();
            }
        });
    }

    // 日付をMM/dd形式に変換するメソッド
    formatMonthDay(date) {
        if (!date || !(date instanceof Date) || isNaN(date)) return '';
        const mm = date.getMonth() + 1;
        const dd = date.getDate();
        return `${mm}/${dd}`;
    }

    // 工法の完了実績と完了日で完了判定し完了時はセルの背景色を黒に（搬入・前検・搬出）
    setCellColorByCarryPretestProcessStatus(result, compleateDate, cell) {
        if (result === '○' && !_.isNil(compleateDate) && compleateDate !== '') {
            cell.value = this.formatMonthDay(new Date(compleateDate));
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '000000' },
            };
            cell.font = {
                name: 'Meiryo UI',
                color: { argb: 'FFFFFFFF' },
            }
        }
    }

    // 工法の完了実績と完了日で完了判定し完了時はセルの背景色を黒に、予定が無ければ"－"表示しセルの背景色を黒くする（ｴｱﾌﾞﾛｰ・ET・FTECT・IRIS）
    setCellColorByProcessStatus(result, compleateDate, processPlan, cell) {
        if (result === '○' && !_.isNil(compleateDate) && compleateDate !== '') {
            cell.value = this.formatMonthDay(new Date(compleateDate));
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '000000' },
            };
            cell.font = {
                name: 'Meiryo UI',
                color: { argb: 'FFFFFFFF' },
            }
        } else if (processPlan === '') {
            cell.value = '－';
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '000000' },
            };
            cell.font = {
                name: 'Meiryo UI',
                color: { argb: 'FFFFFFFF' },
            };
        }
    }

    // 種別毎の工法について開始数/完了数、追加数をカウント
    decideProcess(checkCrisStartArray , checkCrisStartDateArray, checkCrisCompleteArray, checkCrisCompleteDateArray, checkAdditionalReasonArray, item, processPlan, cell) {
        let countStartProcess = 0;
        let countCompleteProcess = 0;
        let latestDate = new Date(0);

        const countAdditionalReason = checkAdditionalReasonArray.filter(key => item[key] !== '').length;
        const processNum = checkCrisStartArray.length;

        for (let i = 0; i < processNum; i++) {
            // 開始チェック
            if (item[checkCrisStartArray[i]] === '○' && !_.isNil(item[checkCrisStartDateArray[i]]) && item[checkCrisStartDateArray[i]] !== '') {
                countStartProcess++;
                const startDate = new Date(item[checkCrisStartDateArray[i]]);
                latestDate = (startDate > latestDate) ? startDate : latestDate;

                // 完了チェック
                if (item[checkCrisCompleteArray[i]] === '○' && !_.isNil(item[checkCrisCompleteDateArray[i]]) && item[checkCrisCompleteDateArray[i]] !== '') {
                    countCompleteProcess++;
                    const completeDate = new Date(item[checkCrisCompleteDateArray[i]]);
                    latestDate = (completeDate > latestDate) ? completeDate : latestDate;
                }
            }
        }
        // 開始しているものがない
        if (countStartProcess === 0) {
            // 計画がなく、追加もない
            if (processPlan === '' && countAdditionalReason === 0) {
                // 実施せず
                cell.value = '－';
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '000000' },
                };
                cell.font = {
                    name: 'Meiryo UI',
                    color: { argb: 'FFFFFFFF' },
                };
            // 計画または追加がある
            } else {
                // 未実施（出力無し）
            }
        // 開始しているものがすべて完了している
        } else if (countStartProcess === countCompleteProcess) {
            // 完了
            cell.value = this.formatMonthDay(latestDate);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '000000' },
            };
            cell.font = {
                name: 'Meiryo UI',
                color: { argb: 'FFFFFFFF' },
            };
        } else {
            // 途中
            cell.value = this.formatMonthDay(latestDate);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFC0C0C0' },
            };
        }
    }

    makeXlsx(heatExchangerArray) {
        // 熱交停止完了チェック処理.
        let instrumentApparatusMachineNumber = this.checkJson(heatExchangerArray);

        // 取得した配列から'heatExchangerId','csvId'の要素を削除.
        const cleanedArray = heatExchangerArray.map(item => {
            const newItem = { ...item };
            delete newItem.heatExchangerId;
            delete newItem.csvId;
            return newItem;
        });

        const wb =  new ExcelJS.Workbook();
        // 全装置記載のシートを追加
        const allApparatusSheet = wb.addWorksheet('進捗管理表', {
            views: [
                {
                    showGridLines: false, // 目盛り線非表示
                }
            ]
        });

        // 全装置記載の表を生成
        this.generateProgressManagementSheet (allApparatusSheet, cleanedArray);

        // 装置ごとにグループ化
        const groups = cleanedArray.reduce((acc, item) => {
            const key = item.instrumentApparatus || 'Unknown';
            if (!acc[key]) acc[key] = [];
            acc[key].push(item);
            return acc;
        }, {});

        // グループごとにシート追加
        Object.entries(groups).forEach(([key, items]) => {
            const groupApparatusSheet = wb.addWorksheet(key, {
                views: [
                    {
                        showGridLines: false, // 目盛り線非表示
                    }
                ]
            });
            this.generateProgressManagementSheet (groupApparatusSheet, items);
        });

        this.setState({ xlsxWorkbook: wb, isWaitDownload: false }, async () => {
            // チェック結果に応じて分岐
            if (instrumentApparatusMachineNumber !== '') {
                let infoMsg = [
                    '停止、完了されていない熱交(' + instrumentApparatusMachineNumber + ')があります。'
                ];
                // メッセージを出して、ダイアログ閉じたら出力するようにする
                this.setState({message: infoMsg,infoDialogXlsxOpen: true,});
            } else {
                //Xlsxファイル出力
                this.downloadXlsx();
            }
        });
    }

    // 進捗管理表生成メソッド
    generateProgressManagementSheet (ws, heatExchangerArray) {
        // 罫線スタイルの定義
        const borderStyle = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };
        const tableBorderStyle = {
            top: { style: 'thin' },
            left: { style: 'hair' },
            bottom: { style: 'thin' },
            right: { style: 'hair' },
        };
        const headerBorderStyle = {
            top: { style: 'thin' },
            left: { style: 'hair' },
            bottom: { style: 'double' },
            right: { style: 'hair' },
        };

        // 表の各列の定義
        const INSTRUMENTAPPARATUS_COLUMN = 1;
        const INSTRUMENTMACHINENUMBER_COLUMN = 2;
        const CARRYIN_COLUMN = 3;
        const PRETEST_COLUMN = 4;
        const CRINTERNAL_COLUMN = 5;
        const CREXTERNAL_COLUMN = 6;
        const CRSHNUM_COLUMN = 7;
        const AIRBLOW_COLUMN = 8;
        const ET_COLUMN = 9;
        const FTETC_COLUMN = 10;
        const IRIS_COLUMN = 11;
        const CARRYOUT_COLUMN = 12;

        // 表ヘッダーの設定
        const headerRow = ws.insertRow(9, [
            '装置', '機番', '搬入', '前検', '内面', '外面', '超高',
            'エアブロー', 'ET', 'FTECT', 'IRIS', '搬出'
        ]);
        // ヘッダーへのスタイル適用
        headerRow.eachCell((cell, colNum) => {
            cell.border = headerBorderStyle;
            // 両端は通常罫線
            if ( colNum === 1 ) {
                cell.border = { 
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'double' },
                    right: { style: 'hair' },
                }
            }
            if ( colNum === headerRow.cellCount ) { 
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'hair' },
                    bottom: { style: 'double' },
                    right: { style: 'thin' },
                };
            }
            cell.font = {
                name: 'Meiryo UI',
                size: 10,
            };
            cell.alignment = {
                horizontal: 'center',
                vertical: 'middle',
            };
        });

        heatExchangerArray.forEach((item) => {
            // 予定工法に一つも値が入っていないかつ追加熱交フラグがない場合はスキップ
            const isProgressScheduled = progressPlanArray.some(v => item[v] !== "") || item.systemInfoAdditionalFlag ==="○";
            if (isProgressScheduled) {
                // 表へのデータ投入
                const row = ws.addRow([
                    item.instrumentApparatus,
                    item.instrumentMachineNumber,
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                ]);
                // 内面・外面・超高のデータ入力・各セルへのスタイル適用
                row.eachCell((cell, colNum) => {
                    cell.border = borderStyle;
                    cell.font = {name: 'Meiryo UI'};
                    cell.alignment = {
                        horizontal: 'center',
                        vertical: 'middle',
                    };

                    cell.border = tableBorderStyle;
                    switch (colNum) {
                        case INSTRUMENTAPPARATUS_COLUMN : // 装置列
                            // 表の左端列のためborder leftは'thin'
                            cell.border = { 
                                top: { style: 'thin' },
                                left: { style: 'thin' },
                                bottom: { style: 'thin' },
                                right: { style: 'hair' },
                            };
                            cell.alignment = {
                                horizontal: 'left',
                                vertical: 'middle',
                            };
                            break;
                        
                        case INSTRUMENTMACHINENUMBER_COLUMN : // 機番列
                            cell.alignment = {
                                horizontal: 'left',
                                vertical: 'middle',
                            };
                            break;

                        // 各列ごとに完了判定を行う
                        case CARRYIN_COLUMN : // 搬入列
                            this.setCellColorByCarryPretestProcessStatus(item.resultOfProcessIsCompleteCarryIn, item.resultOfProcessCarryInDatetime, cell);
                            break;

                        case PRETEST_COLUMN : // 前検列
                            this.setCellColorByCarryPretestProcessStatus(item.resultOfProcessIsCompletePretest, item.resultOfProcessPretestDatetime, cell);
                            break;

                        case CRINTERNAL_COLUMN : // 内面列
                            this.decideProcess(checkCrisStart, checkCrisStartDate, checkCrisComplete, checkCrisCompleteDate, checkCrisAdditionalReasonArray, item, item.planOfCrInternalMpa, cell);
                            break;

                        case CREXTERNAL_COLUMN : // 外面列
                            this.decideProcess(checkCrosStart, checkCrosStartDate, checkCrosComplete, checkCrosCompleteDate, checkCrosAdditionalReasonArray, item, item.planOfCrExternalMpa, cell);
                            break;

                        case CRSHNUM_COLUMN : // 超高列
                            this.decideProcess(checkCrshStart, checkCrshStartDate, checkCrshComplete, checkCrshCompleteDate, checkCrshAdditionalReasonArray, item, item.planOfCrSuperHigh, cell);
                            break;

                        case AIRBLOW_COLUMN : // エアブロー列
                            this.setCellColorByProcessStatus(item.resultOfProcessIsCompleteAirBlow, item.resultOfProcessAirBlowDatetime, item.planOfProcessAirBlow, cell);
                            break;

                        case ET_COLUMN : // ET列
                            this.setCellColorByProcessStatus(item.resultOfProcessIsCompleteEt, item.resultOfProcessEtDatetime, item.planOfProcessEt, cell);
                            break;

                        case FTETC_COLUMN : // FTECT列
                            this.setCellColorByProcessStatus(item.resultOfProcessIsCompleteFtect, item.resultOfProcessFtectDatetime, item.planOfProcessFtect, cell);
                            break;

                        case IRIS_COLUMN : // IRIS列
                            this.setCellColorByProcessStatus(item.resultOfProcessIsCompleteIris, item.resultOfProcessIrisDatetime, item.planOfProcessIris, cell);
                            break;

                        case CARRYOUT_COLUMN : // 搬出列
                            this.setCellColorByCarryPretestProcessStatus(item.resultOfProcessIsCompleteCarryOut, item.resultOfProcessCarryOutDatetime, cell);
                            break;

                        default :
                    }

                    // 表の右端列の場合はborder rightは'thin'
                    if ( colNum === row.cellCount ) { 
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'hair' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' },
                        };
                    }
                });
            }
        });

        // 余白入れるためA列に空列を挿入
        ws.spliceColumns(1, 0, []);
        // 列幅設定
        ws.getColumn(1).width = 3.4;
        for (let i = 2; i < 12; i++) {
            ws.getColumn(i).width = 9.5;
        }
        // 行高さ設定
        ws.getRow(6).height = 10;
        ws.getRow(7).height = 11;
        ws.getRow(8).height = 6.5;
        // 日付・タイトル表示セルのマージ
        ws.mergeCells('L1:M1');
        ws.mergeCells('B4:M4');
        ws.mergeCells('B5:M5');

        // タイトル等出力するセルを取得
        const dateCell = ws.getCell('L1');
        const companyCell = ws.getCell('M2');
        const titleCell = ws.getCell('B4');
        const sceneNameCell = ws.getCell('B5');
        const unWorkedCell = ws.getCell('K7');
        const inProgressCell = ws.getCell('L7');
        const completed_notPerformedCell = ws.getCell('M7');
        const templateCellArray = [dateCell, companyCell, titleCell, sceneNameCell];
        const statusCellArray = [unWorkedCell, inProgressCell, completed_notPerformedCell];

        // 会社名・タイトル・現場名セルにスタイル適用
        companyCell.alignment = {
            horizontal: 'right',
            vertical: 'middle',
        };
        titleCell.alignment = {
            horizontal: 'center',
            vertical: 'middle',
        };
        sceneNameCell.alignment = {
            horizontal: 'center',
            vertical: 'middle',
        };
        // 各セルにデータ出力
        dateCell.value = new Date();
        dateCell.numFmt = 'yyyy/m/d';
        companyCell.value = '栗田工業株式会社';
        titleCell.value = '進捗管理表';
        const fileNameArray = this.state.workPlace.fileName.split('_');
        const title = 
            fileNameArray.length < 2
                ? `${this.state.workPlace.fileName} 年度 SDMジェット洗浄工事`
                : `${this.state.workPlace.fileName} ${fileNameArray[1]}  年度 SDMジェット洗浄工事`;
        sceneNameCell.value = title;
        unWorkedCell.value = '未実施';
        inProgressCell.value = '途中';
        completed_notPerformedCell.value = '完了,実施せず';
        // タイトル等にフォント適用
        for (let templateCell of templateCellArray) {
            templateCell.font = {
                name: 'Meiryo UI',
            };
        }
        // ステータス凡例欄にスタイル適用
        for (let statusCell of statusCellArray) {
            statusCell.alignment = {
                horizontal: 'center',
                vertical: 'middle',
            };
            statusCell.font = {
                name: 'Meiryo UI',
                size: 7,
            };
            statusCell.border = borderStyle;
        }
        inProgressCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFC0C0C0' },
        };
        inProgressCell.font = {
            name: 'Meiryo UI',
            size: 7,
        };
        completed_notPerformedCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '000000' },
        };
        completed_notPerformedCell.font = {
            name: 'Meiryo UI',
            size: 7,
            color: { argb: 'FFFFFFFF' },
        };
    }

    checkJson(json) {
        for(let i = 0; i < checkTargetList.length; i++) {
            let checkTarget = checkTargetList[i];
            // 開始しているのに停止・完了していない熱交を取得.
            let checkResult = json.filter(item => {
                let startProperty = checkTarget[0];
                let stopProperty = checkTarget[1];
                let completeProperty = checkTarget[2];
                return item[startProperty] !== '' && item[stopProperty] === '' && item[completeProperty] === '';
            });
            // 開始しているのに停止・完了していない熱交がある場合に装置機番を返却.
            if(checkResult.length !== 0){
                return checkResult[0].instrumentApparatus + checkResult[0].instrumentMachineNumber;
            }
        }
        return '';
    }

    json2csv(json) {
        // 取得したJSONから'heatExchangerId'の要素を削除.
        let inputItemsIgnoreHeatExchangerId = json.filter(item => {
            return delete item[ 'heatExchangerId' ];
        });
        // 取得したJSONから'csvId'の要素を削除.
        let inputItemsIgnoreCsvId = inputItemsIgnoreHeatExchangerId.filter(item => {
            return delete item[ 'csvId' ];
        });
        // CSV変換.
        let csvLines = inputItemsIgnoreCsvId.map(function(d){
            return Object.keys(d).map(function(key) {
                return d[key];
            }).join(',');
        }).join('\n');
        return csvLines.replace(/\r?\n|\r/g, '\r\n');
    }

    downloadCsv() {
        // CSVファイル出力.
        let uint8Array = new Uint8Array(this.state.csvLines);
        let blob = new Blob([uint8Array], { type: 'text/csv' });
        // For IE.
        if (window.navigator.msSaveBlob) {
            window.navigator.msSaveOrOpenBlob(blob, this.state.workPlace.fileName + '_工事計画_01.csv');
        } else {
            // For Chrome.
            let url = (window.URL || window.webkitURL).createObjectURL(blob);
            let link = document.createElement('a');
            link.download = this.state.workPlace.fileName + '_工事計画_01.csv';
            link.href = url;
            let evt = document.createEvent('MouseEvent');
            evt.initEvent("click", true, false);
            link.dispatchEvent(evt);
        }
        this.setState({message: [], workPlace: null, csvLines: []});
    }

    async downloadXlsx() {
        // xlsxファイル出力.
        const wb = this.state.xlsxWorkbook;
        const fileName = this.state.workPlace.fileName + '_工事計画_01.xlsx';
        // バッファを生成してファイル保存
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            const evt = document.createEvent('MouseEvent');
            evt.initEvent('click', true, false);
            link.dispatchEvent(evt);
        }
        this.setState({ xlsxWorkbook: null, message: [],});
    }

    onAlartDialogClose(){
        // ダイアログを閉じたらエラーメッセージ、選択現場名、CSV出力データ、警告ダイアログ表示フラグをリセット.
        this.setState({message: [], workPlace: null, csvLines: [], alertDialogOpen: false, xlsxWorkbook: null});
    }

    onInfoDialogCloseCsv(){
        // ダイアログを閉じたらエラーメッセージ、情報ダイアログ表示フラグをリセットしてCSVファイル出力.
        this.setState({message: [], infoDialogCsvOpen: false}, () => {
            // CSVファイル出力.
            this.downloadCsv();
        });
    }

    onInfoDialogCloseXlsx(){
        // ダイアログを閉じたらエラーメッセージ、情報ダイアログ表示フラグをリセットしてファイル出力.
        this.setState({message: [], infoDialogXlsxOpen: false}, () => {
            // Xlsxファイル出力.
            this.downloadXlsx();
        });
    }

    render(){
        // KECアカウントでない場合はアクセス不可のためトップ画面へリダイレクト.
        if(!Utility.isKecRole(this.props.cookies.get('role'))){
            return <Redirect to={{pathname: '/'}}/>;
        }

        if(this.state.isWaitGetSceneList){
            // 応答待ち表示.
            return (
                <div className={this.props.classes.circularProgress}>
                    <CircularProgress/>
                </div>
            );
        }else if(this.state.sceneList.length === 0){
            return (                
                <div className={this.props.classes.form}>
                    <div>工事計画CSVが1件もありません。</div>
                    <div className={this.props.classes.button}>
                        <Button component={(props) => <Link to={this.props.backPath} {...props}/>} variant="contained" color="primary" fullWidth>トップ画面へ戻る</Button>
                    </div>
                </div>
            );
        }else{
            return (
                <div className={this.props.classes.form}>
                    <div className={this.props.classes.select}>
                        <Grid container spacing={8}>
                            <Grid item xs={10}>
                                <Select
                                    placeholder="現場名を選択または入力して下さい"
                                    options={this.getItemList()}
                                    value={this.state.workPlace}
                                    onChange={this.onChangeWorkPlace}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Button id="download-csv" href="#" disabled={Utility.isNullOrUndefined(this.state.workPlace)} variant="contained" color="primary" className={this.props.classes.buttonDiv} onClick={this.handleDownloadCsv}>
                                    CSVダウンロード
                                </Button>
                                <Button id="download-xlsx" href="#" disabled={Utility.isNullOrUndefined(this.state.workPlace)} variant="contained" color="primary" style={{ marginTop:16 }} className={this.props.classes.buttonDiv} onClick={this.handleDownloadXlsx}>
                                    装置単位進捗管理表ダウンロード
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={this.props.classes.button}>
                        <Button component={(props) => <Link to={this.props.backPath} {...props}/>} variant="contained" color="primary" fullWidth>トップ画面へ戻る</Button>
                    </div>
                    <Dialog id="wait-dialog" open={this.state.isWaitDownload}>
                        <DialogContent>
                            <CircularProgress className={this.props.classes.circularProgress}/>
                        </DialogContent>
                    </Dialog>
                    <Dialog id="alert-dialog" open={this.state.alertDialogOpen} onClose={this.onAlartDialogClose}>
                        <DialogContent>
                            <DialogContentText style={{whiteSpace: 'pre'}}>
                                {this.state.message}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onAlartDialogClose} color="primary" autoFocus>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog id="info-dialog-csv" open={this.state.infoDialogCsvOpen} onClose={this.onInfoDialogCloseCsv}>
                        <DialogContent>
                            <DialogContentText style={{whiteSpace: 'pre'}}>
                                {this.state.message}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onInfoDialogCloseCsv} color="primary" autoFocus>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog id="info-dialog-xlsx" open={this.state.infoDialogXlsxOpen} onClose={this.onInfoDialogCloseXlsx}>
                        <DialogContent>
                            <DialogContentText style={{whiteSpace: 'pre'}}>
                                {this.state.message}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onInfoDialogCloseXlsx} color="primary" autoFocus>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            );
        }
    }
}

export default withStyles(styles)(DownloadConstructionPlan);
